import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/auth/login'
  },
  {
    path: '/auth',
    component: () => import('@/views/auth/AuthLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/LoginView.vue'),
        meta: { requiresGuest: true }
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/auth/RegisterView.vue'),
        meta: { requiresGuest: true }
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/auth/ForgotPasswordView.vue'),
        meta: { requiresGuest: true }
      }
    ]
  },
  {
    path: '/app',
    component: () => import('@/views/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/app/tasks'
      },
      {
        path: 'household',
        children: [
          {
            path: 'select',
            name: 'HouseholdSelect',
            component: () => import('@/views/household/HouseholdSelectView.vue')
          },
          {
            path: 'create',
            name: 'HouseholdCreate',
            component: () => import('@/views/household/HouseholdCreateView.vue')
          },
          {
            path: 'join',
            name: 'HouseholdJoin',
            component: () => import('@/views/household/HouseholdJoinView.vue')
          },
          {
            path: 'profile',
            name: 'HouseholdProfile',
            component: () => import('@/views/household/HouseholdProfileView.vue')
          },
          {
            path: 'members',
            name: 'HouseholdMembers',
            component: () => import('@/views/household/HouseholdMembersView.vue')
          }
        ]
      },
      {
        path: 'tasks',
        name: 'TaskList',
        component: () => import('@/views/tasks/TaskListView.vue')
      },
      {
        path: 'tasks/create',
        name: 'TaskCreate',
        component: () => import('@/views/tasks/TaskCreateView.vue')
      },
      {
        path: 'tasks/:id',
        name: 'TaskDetail',
        component: () => import('@/views/tasks/TaskDetailView.vue')
      },
      {
        path: 'expenses',
        name: 'ExpenseList',
        component: () => import('@/views/expenses/ExpenseListView.vue')
      },
      {
        path: 'expenses/create',
        name: 'ExpenseCreate',
        component: () => import('@/views/expenses/ExpenseCreateView.vue')
      },
      {
        path: 'expenses/:id',
        name: 'ExpenseDetail',
        component: () => import('@/views/expenses/ExpenseDetailView.vue')
      },
      {
        path: 'expenses/reports',
        name: 'ExpenseReports',
        component: () => import('@/views/expenses/ExpenseReportsView.vue')
      },
      {
        path: 'quotations',
        name: 'QuotationList',
        component: () => import('@/views/expenses/QuotationListView.vue')
      },
      {
        path: 'quotations/create',
        name: 'QuotationCreate',
        component: () => import('@/views/expenses/QuotationCreateView.vue')
      },
      {
        path: 'quotations/:id',
        name: 'QuotationDetail',
        component: () => import('@/views/expenses/QuotationDetailView.vue')
      },
      {
        path: 'mealplans',
        name: 'MealPlanList',
        component: () => import('@/views/mealplans/MealPlanListView.vue')
      },
      {
        path: 'mealplans/create',
        name: 'MealPlanCreate',
        component: () => import('@/views/mealplans/MealPlanCreateView.vue')
      },
      {
        path: 'mealplans/:id',
        name: 'MealPlanDetail',
        component: () => import('@/views/mealplans/MealPlanDetailView.vue')
      },
      {
        path: 'favor',
        name: 'Favor',
        component: () => import('@/views/mealplans/FavorView.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/ProfileView.vue')
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/notifications/NotificationsView.vue')
      },
      {
        path: 'sync-status',
        name: 'SyncStatus',
        component: () => import('@/views/profile/SyncStatusView.vue')
      },
      {
        path: 'audit-events',
        name: 'AuditEvents',
        component: () => import('@/views/profile/AuditEventsView.vue')
      },
      {
        path: 'audit-log',
        name: 'AuditLog',
        component: () => import('@/views/AuditLogView.vue')
      },
      {
        path: 'backup',
        name: 'Backup',
        component: () => import('@/views/BackupView.vue')
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: () => import('@/views/CalendarView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
